import QLVNAgitator from "./QLVNAgitator.vue";
import QLVNAgitatorProperties from "./QLVNAgitatorProperties.vue";
import QLVNAgitatorProperty from "./default.json";

export default {
  install(Vue) {
    Vue.component(QLVNAgitator.name, QLVNAgitator);
    Vue.component(QLVNAgitatorProperties.name, QLVNAgitatorProperties);
    Vue.prototype.$QLVNAgitatorProperties = QLVNAgitatorProperty;
  },
};
